import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import UsedBy from "./UsedBy/UsedBy";
import Speeds from "./Speeds/Speeds";
import CostBy from "./CostBy/CostBy";
import LineTypes from "./LineTypes/LineTypes";


const Lines = () =>{
  
    const chipHeaders = ["Ταχύτητες Γραμμών", "Χρήση Από", "Κόστος ανά", "Είδη Γραμμών"];
    const chipItems: React.ReactNode[] = [
      <Speeds/>,
      <UsedBy />,
      <CostBy/>,
      <LineTypes/>,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default Lines